<template>
    <div class="bg-b">

        <div class="container">
            <el-row :gutter="20">
                <el-col :sm="{ span: 16, offset: 4 }" :offset="0">
                    <el-card shadow="always" style="margin-top:20px" :body-style="{ padding: '20px' }">
                        <div slot="header">
                            <span>Generar Nueva Contraseña</span>
                        </div>
                        <el-form ref="form" :model="formData" :rules="rules"
                            :label-position="$isMobile() ? 'top' : 'left'" label-width="200px" size="normal"
                            style="padding:20px">
                            <el-form-item label="Contraseña" prop="password">
                                <el-input v-model="formData.password" type="password" show-password
                                    autocomplete="off"></el-input>
                            </el-form-item>
                            <br>
                            <el-form-item label="Confirmar Contraseña" prop="confirmPassword">
                                <el-input v-model="formData.confirmPassword" type="password" show-password
                                    autocomplete="off"></el-input>
                            </el-form-item>
                            <br>
                            <el-form-item>
                                <el-button type="primary" :loading="cargando" @click="submitForm">Cambiar
                                    contraseña</el-button>
                            </el-form-item>
                        </el-form>
                    </el-card>

                </el-col>
                <el-col :span="12" :offset="0"></el-col>
            </el-row>

        </div>
    </div>
</template>

<script>
import { HTTP } from "@/axios"
export default {
    data() {
        return {
            cargando: false,
            formData: {
                password: '',
                confirmPassword: '',

            },
            rules: {
                password: [
                    { required: true, message: 'Por favor, introduzca la contraseña', trigger: 'blur' },
                    { min: 6, message: 'La contraseña debe tener al menos 6 caracteres', trigger: 'blur' }
                ],
                confirmPassword: [
                    { required: true, message: 'Por favor, confirme la contraseña', trigger: 'blur' },
                    { validator: this.validateConfirmPassword, trigger: 'blur' }
                ]
            }
        };
    },
    methods: {
        validateConfirmPassword(rule, value, callback) {
            if (value === '') {
                callback(new Error('Por favor, confirme la contraseña'));
            } else if (value !== this.formData.password) {
                callback(new Error('Las contraseñas no coinciden'));
            } else {
                callback();
            }
        },
        submitForm() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    // Envía los datos al servidor o realiza otras acciones
                    this.formData.docente_id = this.$route.query.c
                    this.cargando = true
                    setTimeout(() => {

                        HTTP.post('/docente/nuevoPass', this.formData)
                            .then(res => {
                                this.cargando = false
                                if (res.data) {
                                    this.$alert('Contraseña actualizada', {
                                        confirmButtonText: 'Aceptar',
                                        type: 'success',
                                        callback: () => {
                                            this.$router.push({ name: 'docentes' })
                                        }
                                    })

                                }
                                else {
                                    this.$alert('No pudimos actualizar su contraseña, refresque la página y reitente', {
                                        confirmButtonText: 'Aceptar',
                                        type: 'error'

                                    })
                                }

                            })
                            .catch(() => {
                                this.cargando = false
                                this.$alert('No pudimos actualizar su contraseña, refresque la página y reitente', {
                                    confirmButtonText: 'Aceptar',
                                    type: 'error'

                                })
                            })
                    }, 100);
                } else {
                    // Muestra un mensaje de error o toma otras medidas
                    console.log('Datos inválidos. Por favor, revise los campos.');
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped></style>